import { IconAlarm } from '@assets/images/main/index';
import {
  CameraFunctions1D,
  CameraFunctions1M,
  CameraFunctions1T,
  CameraFunctions2D,
  CameraFunctions2M,
  CameraFunctions2T,
  CameraFunctions3D,
  CameraFunctions3M,
  CameraFunctions3T,
  CameraFunctions4D,
  CameraFunctions4M,
  CameraFunctions4T,
  CameraFunctions5D,
  CameraFunctions5M,
  CameraFunctions5T,
  CameraFunctions6D,
  CameraFunctions6M,
  CameraFunctions6T,
  CameraFunctions7D,
  CameraFunctions7M,
  CameraFunctions7T,
} from '@assets/images/main/camera/main/functions';
import { IconEdgeOff, IconEdgeOn, IconOsOff, IconOsOn, IconServerOff, IconServerOn } from '@assets/images/main/icon';
import {
  cameraBannerBg,
  cameraBannerProduct,
  cameraScreenshot1D,
  cameraScreenshot1M,
  cameraScreenshot1T,
  cameraScreenshot2D,
  cameraScreenshot2M,
  cameraScreenshot2T,
  cameraScreenshot3D,
  cameraScreenshot3M,
  cameraScreenshot3T,
} from '@assets/images/main/camera';
import { IconBlueCircle, IconBlueShield } from '@assets/images/main/icon/blue';
import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';

import { screenViewCamera1, screenViewCamera2, screenViewCamera3, screenViewCamera4, screenViewCamera5 } from '@assets/images/main/screenView';

import { ReactComponent as SvgGridLine } from '@assets/images/icon/svg/grid-line.svg';
import { ReactComponent as SvgLocationLine } from '@assets/images/icon/svg/location-line.svg';
import { ReactComponent as SvgChartLine } from '@assets/images/icon/svg/chart-line.svg';
import { ReactComponent as SvgPencilLine } from '@assets/images/icon/svg/pencil-line.svg';
import { ReactComponent as SvgAi } from '@assets/images/icon/svg/ai.svg';

export default {
  mainPage: {
    product: {
      title: 'Khám phá Cấu hình Sản phẩm',
      desc: 'Xem qua các cấu hình sản phẩm theo dõi vị trí sáng tạo của chúng tôi.',
      outdoor: {
        title: 'Camera Ngoài trời',
        desc: 'Phát hiện và quản lý vị trí cũng như hành vi bất thường của con người, phương tiện và các đối tượng khác qua camera.',
      },
      indoor: {
        title: 'Camera Trong nhà',
        desc: 'Phân tích lộ trình di chuyển của con người trong không gian trong nhà qua camera.',
      },
    },
  },

  banner: {
    title: 'Theo dõi vị trí thời gian thực chỉ bằng hình ảnh video, tự động nhận diện và theo dõi chuyển động của người và phương tiện.',
    desc: 'Có thể dễ dàng theo dõi vị trí của các đối tượng như người và phương tiện với AI Server và AI Edge, hơn nữa là tích hợp hoàn toàn với ORBRO OS.',

    schemeTitle: 'Hệ thống Camera do ORBRO đề xuất',
    schemeDesc: 'Cần tư vấn chọn lựa?',
    schemeDesc2: 'Liên hệ với chúng tôi và<br/>chuyên gia ra vào sẽ hỗ trợ bạn.',
    phone: '1522-9928',

    bgImg: cameraBannerBg,
    productImg: cameraBannerProduct,
  },

  bannerData: [
    {
      icon: IconEdgeOn,
      iconInv: IconEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/vi/camera/edge',
    },
    {
      icon: IconServerOn,
      iconInv: IconServerOff,
      image: '',
      iconText: 'ORBRO AI Server',
      sub: 'New',
      link: '/vi/camera/server',
    },
  ],
  screenView: {
    title: 'Khám phá tức thì từ video thời gian thực',
    data: [
      { icon: SvgGridLine, text: 'Phát trực tuyến nhiều video', img: screenViewCamera1 },
      { icon: SvgLocationLine, text: 'Chuyển đổi thông tin vị trí', img: screenViewCamera2 },
      { icon: SvgChartLine, text: 'Phân tích video chuyên sâu', img: screenViewCamera3 },
      { icon: SvgPencilLine, text: 'Hỗ trợ tính năng gợi ý', img: screenViewCamera4 },
      { icon: SvgAi, text: 'Công cụ nhận diện ngữ cảnh', img: screenViewCamera5 },
    ],
  },
  screenShot: [
    {
      title: 'Theo dõi vị trí chỉ bằng hình ảnh video, không cần gắn thẻ Tag',
      desc: 'Khi người và phương tiện được camera ghi lại, vị trí sẽ được hiển thị trực tiếp trên bản đồ theo thời gian thực.<br/>Dựa trên hình ảnh, chuyển động được nhận diện mà không cần tag riêng, và vị trí đối tượng được quan sát trực quan trên sơ đồ.',
      img: {
        desktop: cameraScreenshot1D,
        tablet: cameraScreenshot1T,
        mobile: cameraScreenshot1M,
      },
    },
    {
      title: 'Không cần phải lắp đặt camera mới',
      desc: 'Nếu là CCTV dựa trên RTSP, ONVIF, bạn có thể bắt đầu theo dõi vị trí qua video AI chỉ với cơ sở hạ tầng hình ảnh hiện có.<br/>Việc cài đặt đơn giản, đồng thời có thể tùy chỉnh mô hình nhận diện đối tượng cho từng camera một cách linh hoạt.',
      img: {
        desktop: cameraScreenshot2D,
        tablet: cameraScreenshot2T,
        mobile: cameraScreenshot2M,
      },
    },
    {
      title: 'AI giải mã ‘hành động" trong không gian, cung cấp thông tin giá trị',
      desc: 'AI hiểu và phân tích tình huống thực tế tại hiện trường, sau đó truyền đạt thông tin đã được xử lý.<br/>Có thể ứng dụng đa dạng như phát hiện tình huống nguy hiểm, giám sát trạng thái công việc, và tự động hóa việc kiểm soát ra vào.',
      img: {
        desktop: cameraScreenshot3D,
        tablet: cameraScreenshot3T,
        mobile: cameraScreenshot3M,
      },
    },
  ],

  video: {
    title: 'Hệ thống Camera AI ORBRO',
    desc: [
      { text: 'Thu thập và phân tích vị trí người và xe ngoài trời.' },
      { text: 'Xác định vị trí di chuyển của con người trong nhà.' },
      { text: 'Tích hợp với hạ tầng camera CCTV hiện có.' },
      { text: 'Dễ dàng thêm camera khi cần.' },
    ],
  },

  func: {
    title: 'Khám phá tính năng của camera',
    desc: 'Khám phá các tính năng đa dạng của camera.',

    data: [
      {
        img: IconBlueShield,
        title: 'Quản lý quyền hạn và nhóm người dùng',
        desc: 'Phân quyền rõ ràng giữa quản trị  và người dùng, kiểm soát truy cập chức năng theo vai trò. Hỗ trợ tạo nhóm theo phòng ban hoặc đội nhóm.',
      },
      {
        img: IconAlarm,
        title: 'Cài đặt thông báo theo điều kiện (5 cấp độ)',
        desc: 'Cho phép cấu hình cảnh báo theo 5 cấp độ dựa trên các điều kiện được thiết lập sẵn, giúp phát hiện nhanh và xử lý kịp thời các dấu hiệu bất thường.',
      },
      {
        img: Icon3dMeter,
        title: 'Giám sát khu vực (Zone)',
        desc: 'Thiết lập Zone trực tiếp trên bản đồ và theo dõi người hoặc tài sản di chuyển vào khu vực đó theo thời gian thực.',
      },
      {
        img: Icon3dCycle,
        title: 'Phát hiện di chuyển ngược chiều',
        desc: 'Hệ thống tự động phát hiện các chuyển động ngược với hướng di chuyển đã định, và phát cảnh báo khi phát hiện bất thường.',
      },
      {
        img: Icon3dDetect,
        title: 'Phát hiện ra/vào khu vực (In/Out Zone)',
        desc: 'Tự động nhận diện việc ra vào và rời khỏi các khu vực được chỉ định, hỗ trợ ghi nhận lịch sử ra vào và phân tích thời gian lưu trú.',
      },
      {
        img: Icon3d3d,
        title: 'Tìm kiếm thiết bị và quản lý trạng thái',
        desc: 'Dễ dàng tìm kiếm nhiều thiết bị Tag và Anchor, theo dõi trạng thái kết nối, mức pin, và quản lý tổng thể một cách trực quan.',
      },
    ],
  },

  functions: {
    title: 'Công nghệ Digital Twin theo dõi vị trí qua AI',
    desc: 'Hệ thống Camera AI ORBRO mang lại độ chính xác và ổn định cao.<br/>Xác định và phân tích vị trí người, xe trong & ngoài nhà để cung cấp dữ liệu cần thiết.',

    line: 3,
    card: [
      {
        size: '3',
        tag: 'Tính năng chính',
        title: 'Đối tượng nhận diện qua video<br/>hiển thị thời gian thực trên bản đồ',
        label: 'Admin',
        img: {
          desktop: CameraFunctions1D,
          tablet: CameraFunctions1T,
          mobile: CameraFunctions1M,
        },
      },
      {
        color: '#fff',
        size: '1',
        tag: 'Dịch vụ Di động',
        title: 'Tất cả không gian,<br/>Trải nghiệm trên di động',
        label: 'Dùng chung',
        img: {
          desktop: CameraFunctions2D,
          tablet: CameraFunctions2T,
          mobile: CameraFunctions2M,
        },
      },
      {
        size: '2',
        tag: 'Tương thích CCTV hiện có',
        title: 'Tương thích mọi<br/>Thông tin video',
        label: 'Admin',
        img: {
          desktop: CameraFunctions3D,
          tablet: CameraFunctions3T,
          mobile: CameraFunctions3M,
        },
      },
      {
        size: '2',
        tag: 'Nhận diện Người & Xe',
        title: 'Phát hiện người & xe<br/>Độ chính xác cao',
        label: 'Admin',
        img: {
          desktop: CameraFunctions4D,
          tablet: CameraFunctions4T,
          mobile: CameraFunctions4M,
        },
      },
      {
        size: '2',
        tag: 'Triển khai Server tại chỗ',
        title: 'Bảo mật chắc chắn<br/>và ổn định nhất',
        label: 'On-Premise',
        img: {
          desktop: CameraFunctions5D,
          tablet: CameraFunctions5T,
          mobile: CameraFunctions5M,
        },
      },
      {
        size: '1',
        tag: 'Lắp đặt quy mô lớn',
        title: 'Phù hợp với bãi đỗ xe<br/>và lắp đặt doanh nghiệp',
        label: 'Enterprise',
        img: {
          desktop: CameraFunctions6D,
          tablet: CameraFunctions6T,
          mobile: CameraFunctions6M,
        },
      },
      {
        size: '3',
        tag: 'Bảng điều khiển',
        title: 'Thông tin Data Insight<br/>Quyết định dựa trên dữ liệu',
        label: 'Admin',
        img: {
          desktop: CameraFunctions7D,
          tablet: CameraFunctions7T,
          mobile: CameraFunctions7M,
        },
      },
    ],
  },

  FAQ: [
    {
      title: 'Hệ thống định vị bằng hình ảnh của ORBRO hoạt động như thế nào?',
      description:
        'Hệ thống thu thập hình ảnh từ camera đã lắp đặt, sau đó AI nhận diện người, phương tiện,...<br/>trong video theo thời gian thực để tính toán vị trí.<br/>Vị trí đã tính sẽ được hiển thị trực quan trên bản đồ thông qua ORBRO OS.',
    },
    {
      title: 'Sự khác biệt lớn nhất giữa ORBRO Edge AI và AI Server là gì?',
      description:
        'ORBRO Edge AI là thiết bị độc lập, thực hiện đồng thời phân tích AI và tính toán vị trí chỉ trên một thiết bị duy nhất.<br/>Trong khi đó, AI Server phân tích tập trung video từ nhiều camera và phải được vận hành cùng với ORBRO Server.',
    },
    {
      title: 'Có thể liên kết với hệ thống CCTV hiện có không?',
      description: 'Vâng. Nếu là camera hỗ trợ giao thức RTSP hoặc ONVIF, có thể liên kết với cả hệ thống CCTV hiện tại.',
    },
    {
      title: 'Có thể sử dụng mà không cần Server không?',
      description:
        'ORBRO Edge AI có thể được sử dụng mà không cần Server riêng biệt.<br/>Tuy nhiên, AI Server bắt buộc phải được vận hành cùng với ORBRO Server.',
    },
    {
      title: 'Định vị qua hình ảnh video có tốt hơn BLE/UWB không?',
      description:
        'Điều này sẽ tùy thuộc vào từng tình huống cụ thể.<br/>Định vị dựa trên hình ảnh video hoạt động mà không cần gắn thẻ Tag riêng biệt, nhưng bị giới hạn bởi góc nhìn.<br/>Trong khi định vị dựa trên sóng vô tuyến (BLE/UWB) có thể hoạt động dù không có tầm nhìn trực tiếp, nhưng cần có thẻ Tag.<br/>ORBRO hỗ trợ khả năng sử dụng kết hợp cả hai phương thức này.',
    },
    {
      title: 'Dữ liệu video có được lưu trữ không? Có vấn đề về bảo mật thông tin cá nhân không?',
      description:
        'Về cơ bản, AI chỉ phân tích video mà không lưu trữ dữ liệu, chỉ thông tin vị trí được lưu trên máy chủ.<br/>Trong trường hợp cần lưu trữ, dữ liệu sẽ được mã hóa và thiết lập quyền truy cập bảo mật.',
    },
    {
      title: 'Đối tượng phân tích chỉ có người thôi phải không?',
      description:
        'Đối tượng cơ bản là người, nhưng tuỳ theo thiết lập có thể phân tích thêm xe cộ, thiết bị, và trang bị bảo hộ (ví dụ: tình trạng đội mũ bảo hiểm của công nhân).',
    },
    {
      title: 'Có thể nhận thông báo thời gian thực không?',
      description:
        'Vâng, có thể ạ.<br/>Tuỳ theo các điều kiện đã cài đặt (ví dụ: đối tượng đi vào vùng Zone, không phát hiện được đối tượng, v.v.), hệ thống có thể gửi thông báo thời gian thực (qua Push, Email, Webhook, v.v.) cho người quản trị.',
    },
  ],
};
